<script>
import {HorizontalBar} from 'vue-chartjs'


export default HorizontalBar.extend({
  name: 'horizontal-bar-chart',
  /**
   *
   * @returns {{options: {responsive: boolean, responsiveAnimationDuration: number, legend: {display: boolean}, scales: {xAxes: [*], yAxes: [*]}}}}
   */
  data() {
    return {
      options: {
        responsive: false,
        responsiveAnimationDuration: 0,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontSize: 40,
              callback(value, index, values) {
                return value + '%'
              },
              offset: true
            }
          }],
          yAxes: [{
            maxBarThickness: 100,
            ticks: {
              fontFamily: '"Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
              fontSize: 40,
            }
          }]
        },
        animation: {
          duration: 0,
          onComplete: function () {
            let chartInstance = this.chart
            let ctx = chartInstance.ctx

            ctx.font = Chart.helpers.fontString(40, 40, Chart.defaults.global.defaultFontFamily)
            ctx.textAlign = 'center'
            ctx.textBaseline = 'bottom'
            this.data.datasets.forEach(function (dataset, i) {
              const maxValue = Math.max(...dataset.data)

              const meta = chartInstance.controller.getDatasetMeta(i)
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index]
                let labelConfig = null
                if (data / maxValue > .22) {
                  labelConfig = {
                    color: '#fff',
                    horizontalOffset: -90
                  }
                } else {
                  labelConfig = {
                    color: '#333',
                    horizontalOffset: 90
                  }
                }
                ctx.fillStyle = labelConfig.color
                ctx.fillText(data.toFixed(2).replace('.', ',') + ' %', bar._model.x + labelConfig.horizontalOffset, bar._model.y + 23)
              })
            })
          }
        }
      }
    }
  },

  props: ['chartData', 'settings'],

  mounted() {
    this.renderChart(this.chartData, this.options)
    setTimeout(() => {
      this.$emit('generateChartImage', this._chart.toBase64Image())
    }, 2000)
  }
})
</script>



// WEBPACK FOOTER //
// ChartHorizontalBar.vue?c88c6306